module.exports = __webpack_public_path__ + "04_bob_brown.5e06a49c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_bob_brown.png
// module id = 4vZw
// module chunks = 0